import { locale } from 'config';

export const numberToCurrency = function (number, localisation) {
  let currency = localisation.locales.currency || 'NZD';
  const fractionDigits = 2;
  if (
    isNullOrUndefined(number) ||
    parseFloat(number.toFixed(fractionDigits)) === 0
  ) {
    number = 0;
  }
  return number.toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
};

export const getDisplayName = (ReactComponent) =>
  ReactComponent.displayName || ReactComponent.name || 'Component';

export const isNullOrUndefined = (value) => {
  return value === null || value === undefined;
};

export const isNotEmptyArray = (arr) => Array.isArray(arr) && arr.length > 0;

export const isNegativeNumber = function (number) {
  return number < 0;
};
